export const updateDashboardDocumentCounts = async ({
  updateCartCount,
  updateFavouriteCount,
  updateDocumentsCount,
}) => Promise.all([
  updateCartCount(),
  updateFavouriteCount(),
  updateDocumentsCount(),
]);